"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileCollectionValidationErrorType = void 0;
var FileCollectionValidationErrorType;
(function (FileCollectionValidationErrorType) {
    FileCollectionValidationErrorType["FileTooLarge"] = "file-too-large";
    FileCollectionValidationErrorType["TotalSizeExceeded"] = "total-size-exceeded";
    FileCollectionValidationErrorType["TooManyFiles"] = "too-many-files";
    FileCollectionValidationErrorType["InvalidFilename"] = "invalid-filename";
    FileCollectionValidationErrorType["PathTraversal"] = "path-traversal";
    FileCollectionValidationErrorType["PathTooDeep"] = "path-too-deep";
    FileCollectionValidationErrorType["PathTooLong"] = "path-too-long";
    FileCollectionValidationErrorType["BlockedExtension"] = "blocked-extension";
    FileCollectionValidationErrorType["FileValidationFailed"] = "file-validation-failed";
    FileCollectionValidationErrorType["UnrecognizedFileType"] = "unrecognized-file-type";
    FileCollectionValidationErrorType["ForeignToolFile"] = "foreign-tool-file";
    FileCollectionValidationErrorType["MixedProjectTypes"] = "mixed-project-types";
    FileCollectionValidationErrorType["MultipleProjectsDetected"] = "multiple-projects-detected";
    FileCollectionValidationErrorType["UnrecognizedProjectType"] = "unrecognized-project-type";
    FileCollectionValidationErrorType["MissingReferencedFile"] = "missing-referenced-file";
    FileCollectionValidationErrorType["MissingRequiredFile"] = "missing-required-file";
    FileCollectionValidationErrorType["InconsistentStructureFile"] = "inconsistent-structure-file";
    FileCollectionValidationErrorType["UnpairedStructureFile"] = "unpaired-structure-file";
    FileCollectionValidationErrorType["NetlistExcludedFromTypeDetection"] = "netlist-excluded-from-type-detection";
})(FileCollectionValidationErrorType || (exports.FileCollectionValidationErrorType = FileCollectionValidationErrorType = {}));
//# sourceMappingURL=file-collection-validation-types.js.map